import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { threadDocumentsQueryKey } from "@/features/chat/documents/useThreadDocuments";
import { publishThreadDocumentsChanged } from "@/features/chat/documents/threadDocumentsEvents";
/**
 * Removing a chip is a cancellation, not just a UI change.
 *
 * Previously it dropped local state only: the request ran to completion, the
 * document was created and indexed. The V2 upload registry owns both cleanup
 * handles, so it can delete by operation key before completion and by document
 * id afterwards. Library documents are never registered there.
 */
export function useRemoveAttachment({ setAttachments, uploads }) {
  const queryClient = useQueryClient();
  return useCallback(
    (id) => {
      setAttachments((prev) => {
        const removed = prev.find((a) => a.id === id);
        if (removed?.previewUrl) URL.revokeObjectURL(removed.previewUrl);
        return prev.filter((a) => a.id !== id);
      });
      const cancelled = uploads.cancel(id);
      if (cancelled?.chatId) {
        void Promise.resolve(cancelled.cleanup).finally(() => {
          queryClient.invalidateQueries({
            queryKey: threadDocumentsQueryKey(cancelled.chatId),
          });
          publishThreadDocumentsChanged(cancelled.chatId);
        });
      }
    },
    [queryClient, setAttachments, uploads],
  );
}
